import React, { createContext, useContext, useEffect, useReducer } from "react";
import { QueryUsersWithFilter } from "../databases/users";
import { AuthContext } from "./AuthContext";

export const AdminContext = createContext({});

export const initialFilter = {
    0 : {
        field : '-',
        value : '',
    },
    1 : {
        field : '-',
        value : '',
    },
    2 : {
        field : '-',
        value : '',
    }
}

const initialState = {
    users : {},
    urls : {},
    filters : {...initialFilter},
    filterLoading : false,
    colorFilters : {
        'isInfected' : true,
        'isChecked' : true,
        'isHighlight' : true,
        'white' : true
    }
}

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_USERS":
            return {...state, users : action.payload}
        case "UPDATE_USER":
            return {...state, users : {...state.users, [action.payload.keyname] : {...action.payload.data}}}
        case "SET_URLS":
            return {...state, urls : action.payload}
        case "SET_FLITERS":
            return {...state, filters : action.payload}
        case "SET_FLITERS_LOADING":
            return {...state, filterLoading : action.payload}
        case "SET_COLOR_FILTER":
            return {...state, colorFilters : {...state.colorFilters, [action.payload] : !state.colorFilters[action.payload] } }
        default:
            break;
    }
}

export const AdminProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const { users, filters, filterLoading, colorFilters } = state;
    const setUsers = payload => dispatch({ type: 'SET_USERS', payload });
    const setUrls = payload => dispatch({ type: 'SET_URLS', payload });
    const setFilters = payload => dispatch({ type: 'SET_FLITERS', payload });
    const setFilterLoading = payload => dispatch({ type: 'SET_FLITERS_LOADING', payload });
    const updateSingleUser = (keyname, data) => dispatch({ type: 'UPDATE_USER', payload : {keyname, data} });
    const setColorFilter = payload => dispatch({ type: 'SET_COLOR_FILTER', payload });

    const { userRole, managerRound } = useContext(AuthContext)

    const onSearchClick = async (filters) => {
        setFilterLoading(true)
        let needQuery = false
        for (let i = 0; i < 3; i++) {
            if (filters[i].value) needQuery = true
        }
        if (needQuery) {
            let u = userRole >= 2 ? await QueryUsersWithFilter(filters) : userRole === 1 ? await QueryUsersWithFilter(filters, managerRound) : {} 
            setUsers(u)
            setFilterLoading(false)
        }
        else if (!needQuery) {
            setUsers({})
            setFilterLoading(false)
        }
    }

    const onClearFilter = () => {
        setUsers({})
        setFilters({...initialFilter})
    }

    useEffect(() => {
        return () => {
            setUsers({})
            setUrls({})
            setFilters({...initialFilter})
        }
    }, [])

    return (
        <AdminContext.Provider value={{ users, filters, setFilters, updateSingleUser, filterLoading, setFilterLoading, onSearchClick, onClearFilter, colorFilters, setColorFilter }}>
            {children}
        </AdminContext.Provider>
    )

}